/* eslint-disable react-hooks/exhaustive-deps */
import { Image, Pencil } from 'lucide-react'
import { useEffect, useMemo, useState } from 'react'
import { Card, Col, Container, Form, Row } from 'react-bootstrap'
import { useDropzone } from 'react-dropzone'
import Select from 'react-select'
import Loader from '../../../components/atoms/Loader/index'
import api from '../../../config/AxiosInstance'
import '../../../styles/style.css'
import toast, { Toaster } from 'react-hot-toast'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const SelectStyles = {
  control: (base, state) => ({
    ...base,
    height: 45,
    minHeight: 45,
    borderRadius: '10px',
    borderColor: state.isFocused ? 'var(--primary-orange)' : '#e9ecef',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(248, 157, 29, 0.1)' : 'none',
    backgroundColor: '#ffffff',
    border: '1px solid #e9ecef',
    fontSize: '0.9rem'
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '45px',
    padding: '0 12px'
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px'
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#495057'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? 'var(--primary-orange)'
      : state.isFocused
        ? '#fff5e6'
        : null,
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer'
  })
}

const UploadMap = () => {
  const baseStyle = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '40px',
    borderWidth: 2,
    borderRadius: '12px',
    borderColor: '#e9ecef',
    borderStyle: 'dashed',
    backgroundColor: '#f8f9fa',
    color: '#6c757d',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    cursor: 'pointer',
    minHeight: '400px',
    justifyContent: 'center'
  }

  const focusedStyle = {
    borderColor: 'var(--primary-orange)'
  }

  const acceptStyle = {
    borderColor: '#00e676',
    backgroundColor: '#e8f5e9'
  }

  const rejectStyle = {
    borderColor: '#ff1744',
    backgroundColor: '#ffebee'
  }

  const [options, setOptions] = useState([])
  const [inputValue, setInputValue] = useState('')
  const [selectedValue, setSelectedValue] = useState(null)
  const [files, setFiles] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const onDrop = async (acceptedFiles) => {
    if (acceptedFiles.length === 0) return

    if (acceptedFiles[0].size > 5242880) {
      toast.error('Cant upload file more than 5 MB', {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
      return
    }

    const validTypes = ['image/jpg', 'image/jpeg', 'image/png', 'image/svg+xml']
    if (!validTypes.includes(acceptedFiles[0].type)) {
    }

    try {
      setIsLoading(true)
      if (!selectedValue) {
        toast.error(
          'Please select warehouse value, before upload image warehouse',
          {
            position: 'top-right',
            style: {
              fontSize: '14px',
              fontWeight: '600'
            }
          }
        )
        setIsLoading(false)
        return
      }

      const formData = new FormData()
      formData.append('warehouse_id', selectedValue?.value)
      formData.append('map_image', acceptedFiles[0])

      const res = await api.postForm('settings/map', formData)
      const results = res.data
      setFiles([results.data])
      setIsLoading(false)
      toast.success('Upload map successfully', {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } catch (error) {
      setIsLoading(false)
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    }
  }

  const {
    acceptedFiles,
    getRootProps,
    getInputProps,
    isFocused,
    isDragAccept,
    isDragReject
  } = useDropzone({
    multiple: false,
    accept: {
      'image/jpeg': [],
      'image/png': [],
      'image/svg+xml': []
    },
    onDrop,
    maxSize: 5242880
  })

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isFocused ? focusedStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isFocused, isDragAccept, isDragReject]
  )

  useEffect(
    function () {
      const controller = new AbortController()
      fetchWarehouses(inputValue, controller)
      return function () {
        controller.abort()
      }
    },
    [inputValue]
  )

  useEffect(() => {
    return () => files.forEach((file) => URL.revokeObjectURL(file.preview))
  }, [])

  const handleInputChange = (newValue) => {
    setInputValue(newValue)
  }

  const handleSelectChange = (selectedOption) => {
    setSelectedValue(selectedOption)
    if (selectedOption?.value) {
      fetchShowMapWarehouse(selectedOption.value)
    } else {
      setFiles([])
    }
  }

  async function fetchWarehouses(inputValue, controller) {
    try {
      const params = inputValue ? `?q=${inputValue}` : ''
      const res = await api.get(
        `master/warehouses/all${params}?is_parent=true&forUser=1`,
        {
          signal: controller.signal
        }
      )
      const optionValue = []
      if (res.data.data.length > 0) {
        res.data.data.map((warehouse) =>
          optionValue.push({
            value: warehouse.id,
            label: warehouse.warehouse_name
          })
        )
      }

      setOptions(optionValue)
    } catch (err) {
      if (err.message !== 'canceled') {
        const errMsg =
          err?.response?.data?.errors?.message || 'An error occurred'
        toast.error(errMsg, {
          position: 'top-right',
          style: {
            fontSize: '14px',
            fontWeight: '600'
          }
        })
      }
    }
  }
  async function fetchShowMapWarehouse(id) {
    try {
      setIsLoading(true)
      const res = await api.get(`settings/map/${id}`)
      const results = res.data
      setFiles([results.data])
      setIsLoading(false)
    } catch (err) {
      setFiles([])
      setIsLoading(false)
    }
  }

  return (
    <Container fluid className="px-4">
      <Row className="mb-4">
        <Col>
          <h3 style={headerTitleStyle}>Upload Map</h3>
        </Col>
      </Row>

      <Card style={cardFilterStyle}>
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label style={labelStyle}>Warehouse</Form.Label>
              <Select
                id="warehouse_customer"
                name="warehouse_customer"
                options={options}
                onInputChange={handleInputChange}
                onChange={handleSelectChange}
                placeholder="Search Warehouse..."
                isClearable
                isSearchable
                styles={SelectStyles}
                value={selectedValue}
              />
            </Form.Group>
          </Col>
        </Row>
      </Card>

      <Row>
        <Col xs={12}>
          <div className="mt-3">
            <div {...getRootProps({ style })}>
              {isLoading ? (
                <div className="d-flex h-100 align-items-center justify-content-center flex-column">
                  <Loader />
                  <p className="fw-bold mt-3 text-secondary">Loading Map...</p>
                </div>
              ) : (
                <DragAndDropFile
                  acceptedFiles={acceptedFiles}
                  getInputProps={getInputProps}
                  selectedValue={selectedValue}
                  files={files}
                  isLoading={isLoading}
                />
              )}
            </div>
          </div>
        </Col>
      </Row>

      <Toaster />
    </Container>
  )
}

function DragAndDropFile(props) {
  const imgStyle = {
    maxWidth: '100%',
    maxHeight: '400px',
    objectFit: 'contain',
    borderRadius: '8px',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
  }

  const { files, selectedValue, getInputProps } = props

  const hasFile =
    files.length > 0 && (files[0].warehouse_map || files[0].preview)
  const fileSource =
    files.length > 0 ? files[0].warehouse_map || files[0].preview : null
  const fileName =
    files.length > 0 ? files[0].warehouse_name || 'New Image' : ''

  if (hasFile) {
    return (
      <>
        <input {...getInputProps()} disabled={!selectedValue} />
        <div className="d-flex flex-column w-100">
          <div className="d-flex justify-content-end w-100 mb-3">
            <button
              className="btn btn-primary-orange rounded px-3 py-2 shadow-sm"
              style={{ fontSize: '0.85rem' }}
            >
              <Pencil size={16} className="me-2" />
              Change Image
            </button>
          </div>

          <div className="text-center">
            <img src={fileSource} style={imgStyle} alt={fileName} />
          </div>

          <p className="text-muted text-center mt-3 small">
            Click or Drag & Drop to replace
          </p>
        </div>
      </>
    )
  }

  return (
    <>
      <input {...getInputProps()} disabled={!selectedValue} />
      <div className="d-flex flex-column align-items-center justify-content-center text-center">
        <Image size={64} color="#dee2e6" style={{ marginBottom: '1rem' }} />
        <h5 className="fw-bold text-secondary mb-2">
          {!selectedValue
            ? 'Select a Warehouse First'
            : 'Drag & Drop your image here'}
        </h5>
        <p className="text-muted mb-0">
          {!selectedValue
            ? 'Please select a warehouse from the dropdown above to view or upload a map.'
            : 'or click to browse from your computer'}
        </p>
        {selectedValue && (
          <p className="text-muted small mt-2">
            Supported: JPG, PNG, SVG (Max 5MB)
          </p>
        )}
      </div>
    </>
  )
}

export default UploadMap
